import { containsQuery, queryParams } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/planning";

const getTrailerTypes = () => request(`${resource}/getTrailerTypes`, { method: "GET" });

const getCarGroups = (params: {}) => request(`${resource}/getCarGroups${containsQuery(params)}`, { method: "GET" });

const getResponsibles = () => request(`${resource}/getResponsibles`, { method: "GET" });

const getCounterpartiesInRegion = (params: {}) =>
    request(`${resource}/getCounterpartiesInRegion${queryParams(params)}`, { method: "GET" });

export { getTrailerTypes, getResponsibles, getCounterpartiesInRegion, getCarGroups };
